<app-module>
  <div class="header" header> Support Anfrage Stellen</div>

  <div class="content">
    <form [formGroup]="supportForm" (ngSubmit)="submitSupportForm($event)">
      
      <div class="input-row">
        <app-input [error]="supportForm.controls['subject'].invalid && supportForm.controls['subject'].touched">
            {{'SUPPORT.labelSubject' | translate}}
          <input [formControlName]="'subject'" type="text" placeholder="{{'SUPPORT.placeholderSubject' | translate}}">
          <div app-input-error *ngIf="supportForm.controls['subject'].invalid && supportForm.controls['subject'].touched">
              {{ 'GENERAL.FORMS.requiredInvalid' | translate }}
          </div>
        </app-input>
      </div>
  
      <div class="input-row">
        <app-input [error]="supportForm.controls['message'].invalid && supportForm.controls['message'].touched">
            {{'SUPPORT.labelMessage' | translate}}
          <textarea [formControlName]="'message'" placeholder="{{'SUPPORT.placeholderMessage' | translate}}" rows="5"></textarea>
          <div app-input-error *ngIf="supportForm.controls['message'].invalid && supportForm.controls['message'].touched">
              {{ 'GENERAL.FORMS.requiredInvalid' | translate }}
          </div>
        </app-input>
      </div>
      
      <div class="button-row">
        <button typte="submit" mat-raised-button color="accent" [disabled]="!supportForm.valid">{{'SUPPORT.sendBtn' | translate}}</button>
      </div>

      <p *ngIf="result">{{result | translate}}</p>
    </form>
  </div>

</app-module>


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/support/support.component.html